/**
 * section-advantage.js
 * Progressive-enhancement scroll reveal for the Advantage section.
 * Nothing is hidden until JS confirms it can reveal it again, so the
 * section stays fully visible with JS disabled or blocked.
 */
(function () {
  'use strict';

  var REVEAL_SELECTOR = '.adv--reveal';

  function init(root) {
    var scope = root || document;
    var sections = scope.querySelectorAll(REVEAL_SELECTOR);
    if (!sections.length) return;

    var reduced =
      window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduced || !('IntersectionObserver' in window)) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -8% 0px' }
    );

    sections.forEach(function (section) {
      if (section.dataset.advReady === 'true') return;
      section.dataset.advReady = 'true';
      section.classList.add('adv--animate'); // adds the hidden start state
      observer.observe(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  // Theme editor: re-run when a section is added or re-rendered, and show
  // content immediately so merchants never edit an invisible block.
  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
    var section = event.target.querySelector(REVEAL_SELECTOR);
    if (section) section.classList.add('is-visible');
  });

  document.addEventListener('shopify:block:select', function (event) {
    var section = event.target.closest(REVEAL_SELECTOR);
    if (section) section.classList.add('is-visible');
  });
})();